export default function Machines_D_5 (number = 1) {
  return {
    name: '分馏塔',
    icon: '/static/img/machines/d5.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_5.js